import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Broadcast, Lightning } from "@phosphor-icons/react";
import { timeAgo } from "@/pages/Dashboard";

export default function WebhooksPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/webhooks/events").then(r => setEvents(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="space-y-8">
      <div>
        <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-500">Step 5 · Webhooks</div>
        <h1 className="font-display text-4xl font-bold tracking-tight mt-1">Webhook Events</h1>
        <p className="mt-1.5 text-sm text-slate-500 max-w-2xl">Razorpay sends events like <code className="font-mono">account.app.authorization_revoked</code> when a sub-merchant disconnects. Configure your webhook URL when creating an application.</p>
      </div>

      <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
        <div className="flex items-start gap-3">
          <Lightning size={18} weight="fill" className="text-amber-700 mt-0.5" />
          <div className="text-xs text-amber-900">
            <div className="font-semibold">Receiver endpoint</div>
            <div className="font-mono mt-1">POST {process.env.REACT_APP_BACKEND_URL}/api/webhooks/razorpay</div>
            <div className="mt-2">Send a JSON body with <code className="font-mono">event</code> and <code className="font-mono">account_id</code>. The dashboard will route the event to the right partner workspace.</div>
          </div>
        </div>
      </div>

      {loading ? <div className="text-sm text-slate-500">Loading…</div> : events.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-12 text-center" data-testid="empty-webhooks">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#FFF3E0]">
            <Broadcast size={24} className="text-[#FF6B00]" />
          </div>
          <h3 className="font-display text-lg font-semibold">No webhook events yet</h3>
          <p className="mt-1.5 mx-auto max-w-md text-sm text-slate-500">Events fire automatically when you revoke a sub-merchant's authorization, or when Razorpay POSTs to your webhook URL.</p>
        </div>
      ) : (
        <div className="rounded-xl border border-[#E2E8F0] bg-white overflow-hidden">
          <table className="w-full text-sm" data-testid="webhooks-table">
            <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500">
              <tr>
                <th className="px-4 py-3 text-left font-semibold">Event</th>
                <th className="px-4 py-3 text-left font-semibold">Account</th>
                <th className="px-4 py-3 text-left font-semibold">Received</th>
                <th className="px-4 py-3 text-left font-semibold">Payload</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E2E8F0]">
              {events.map(e => (
                <tr key={e.id} className="hover:bg-orange-50/40">
                  <td className="px-4 py-3"><span className="rounded-full bg-[#FFF3E0] px-2 py-0.5 text-[10px] font-medium font-mono text-[#FF6B00]">{e.event}</span></td>
                  <td className="px-4 py-3 font-mono text-xs">{e.account_id || "—"}</td>
                  <td className="px-4 py-3 text-xs text-slate-500">{timeAgo(e.created_at)}</td>
                  <td className="px-4 py-3 text-xs"><code className="rounded bg-slate-100 px-2 py-0.5">{Object.keys(e.payload || {}).length ? JSON.stringify(e.payload).slice(0, 60) + "…" : "—"}</code></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
